import type { LucideIcon } from 'lucide-react';
import { FileSpreadsheet, PenLine, ShoppingBag, Store, Table2 } from 'lucide-react';
import type { ProductSource } from '../mockKnowledge';

/**
 * Per-source display metadata for products. Tailwind's JIT scanner needs
 * *literal* class strings — it can't see `` `bg-channel-${key}` `` template
 * interpolation — so every class each source needs is spelled out in full
 * here rather than assembled dynamically (same pattern as
 * `integrations/components/channelMeta.ts`). Shopify/WooCommerce reuse the
 * existing channel tokens; the three non-store sources (manual/CSV/sheet)
 * use primary/secondary/muted combinations since they have no channel token.
 */
export interface SourceMeta {
  key: ProductSource;
  name: string;
  icon: LucideIcon;
  badgeClassName: string;
  iconBg: string;
  iconText: string;
}

export const sourceMeta: Record<ProductSource, SourceMeta> = {
  shopify: {
    key: 'shopify',
    name: 'Shopify',
    icon: ShoppingBag,
    badgeClassName: 'border-transparent bg-channel-shopify/10 text-channel-shopify',
    iconBg: 'bg-channel-shopify/10',
    iconText: 'text-channel-shopify',
  },
  woocommerce: {
    key: 'woocommerce',
    name: 'WooCommerce',
    icon: Store,
    badgeClassName: 'border-transparent bg-channel-woocommerce/10 text-channel-woocommerce',
    iconBg: 'bg-channel-woocommerce/10',
    iconText: 'text-channel-woocommerce',
  },
  manual: {
    key: 'manual',
    name: 'Manual',
    icon: PenLine,
    badgeClassName: 'border-transparent bg-primary/10 text-primary',
    iconBg: 'bg-primary/10',
    iconText: 'text-primary',
  },
  csv: {
    key: 'csv',
    name: 'CSV / Excel',
    icon: FileSpreadsheet,
    badgeClassName: 'border-transparent bg-secondary text-secondary-foreground',
    iconBg: 'bg-secondary',
    iconText: 'text-secondary-foreground',
  },
  sheet: {
    key: 'sheet',
    name: 'Google Sheet',
    icon: Table2,
    badgeClassName: 'border-border bg-muted text-muted-foreground',
    iconBg: 'bg-muted',
    iconText: 'text-muted-foreground',
  },
};
